// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__vLHXO","location":"Header_location__3U34r"};